export default "__VITE_ASSET__CdOvqPbt__"